/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="m22.5.871-.0029-.1472c-.042-.3846-.3518-.6959-.7484-.7238l-.1461.0029c-.3816.0424-.6905.3546-.7182.7543l-.3569 5.1266a11.4367 11.4367 0 0 0-1.392-1.603c-2.067-1.9752-4.8344-3.1314-7.7987-3.1314C5.0757 1.1494 0 6.2647 0 12.5747S5.0757 24 11.3368 24c2.9503 0 5.7247-1.1417 7.8183-3.1515a11.4505 11.4505 0 0 0 2.4801-3.4908c.1874-.4092.0102-.8941-.3959-1.083-.406-.1888-.8871-.0102-1.0746.399a9.8168 9.8168 0 0 1-2.1267 2.993c-1.7953 1.7235-4.171 2.7011-6.7012 2.7011-5.3667 0-9.7172-4.3845-9.7172-9.7931 0-5.4086 4.3505-9.7931 9.7172-9.7931 2.3806 0 4.6122.8692 6.3415 2.3711a9.7953 9.7953 0 0 1 1.4792 1.608l-4.744-.3344-.1461.0028c-.3816.0423-.6905.3545-.7183.7542-.0313.4496.305.8396.7511.8712l7.6638.5417L22.5.871Zm-.1192-.0097c0-.0004-.0001.0005 0 0Z"
    clipRule="evenodd"
  />,
  'Autosave'
);
